var _dec, _class, _VideoPlayerControls;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyle, jsx } from '@instructure/emotion';
import PlayPauseButton from '../PlayPauseButton';
import Timebar from '../Timebar';
import generateStyle from './styles';
import * as VideoStates from '../videoStates';

/**
---
private: true
---
**/
let VideoPlayerControls = (_dec = withStyle(generateStyle, null), _dec(_class = (_VideoPlayerControls = class VideoPlayerControls extends Component {
  constructor(...args) {
    super(...args);
    this.preventBubbling = e => {
      e.stopPropagation();
      this.props.actions.showControls();
    };
    this.handleTimebarClick = time => {
      this.props.actions.seek(time);
    };
    this.buttonRef = el => {
      this.playButton = el;
    };
    this.timebarRef = el => {
      this.timebar = el;
    };
  }
  componentDidMount() {
    this.props.makeStyles();
    this.props.onMount({
      playButton: this.playButton,
      timebar: this.timebar
    });
  }
  componentDidUpdate() {
    this.props.makeStyles();
  }
  render() {
    const _this$props = this.props,
      state = _this$props.state,
      duration = _this$props.duration,
      buffered = _this$props.buffered,
      currentTime = _this$props.currentTime,
      actions = _this$props.actions,
      videoId = _this$props.videoId,
      styles = _this$props.styles,
      hideTimeBar = _this$props.hideTimeBar;

    /* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
    return jsx("div", {
      css: styles.container,
      onClick: this.preventBubbling
    }, jsx(PlayPauseButton, {
      variant: state,
      onClick: actions.togglePlay,
      videoId: videoId,
      buttonRef: this.buttonRef
    }), !hideTimeBar ? jsx(Timebar, {
      duration: duration,
      currentTime: currentTime,
      buffered: buffered,
      videoId: videoId,
      onClick: this.handleTimebarClick,
      timebarRef: this.timebarRef
    }) : null);
    /* eslint-enable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
  }
}, _VideoPlayerControls.propTypes = {
  // eslint-disable-next-line react/require-default-props
  makeStyles: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  styles: PropTypes.object,
  actions: PropTypes.shape({
    seek: PropTypes.func.isRequired,
    togglePlay: PropTypes.func.isRequired,
    showControls: PropTypes.func.isRequired
  }).isRequired,
  /**
   * Id of the video element. Used to ensure
   * correct aria properties are applied.
   */
  videoId: PropTypes.string.isRequired,
  state: PropTypes.oneOf(Object.values(VideoStates)).isRequired,
  /**
   * Number of seconds that have been buffered.
   */
  buffered: PropTypes.number,
  /**
   * The current playback time in seconds.
   */
  currentTime: PropTypes.number,
  /**
   * The length of the video in seconds.
   */
  duration: PropTypes.number,
  showControls: PropTypes.bool,
  onMount: PropTypes.func,
  hideTimeBar: PropTypes.bool
}, _VideoPlayerControls.defaultProps = {
  showControls: false,
  duration: 0,
  buffered: 0,
  currentTime: 0,
  onMount({
    playButton,
    timebar
  }) {},
  hideTimeBar: false
}, _VideoPlayerControls)) || _class);
export default VideoPlayerControls;